import styles from "./ErrorBoundaryFallbackScreen.module.scss";

import { useTranslation } from "react-i18next";

import { AppButton } from "../../components/AppButton/AppButton";

interface ErrorBoundaryFallbackScreenProps {
  resetError: () => void;
}

export const ErrorBoundaryFallbackScreen = ({
  resetError,
}: ErrorBoundaryFallbackScreenProps) => {
  const { t } = useTranslation();

  const handleReload = () => {
    resetError();
    window.location.reload();
  };

  return (
    <div className={styles.layout}>
      <div className={styles.container} role="alert">
        <h1 className={styles.title}>{t("common.errorBoundary.title")}</h1>
        <p className={styles.description}>
          {t("common.errorBoundary.description")}
        </p>
        <AppButton onClick={handleReload}>
          {t("common.errorBoundary.reload")}
        </AppButton>
      </div>
    </div>
  );
};
